/**
 * Dynamic Environments Environment Variable Swapper
 *
 * This plugin will only run when used within a dynamic environment.
 *
 * When the Docker image is built, during the container runtime we will
 * inject a dynamic-environments-env.js which is autogenerated in the
 * Docker entrypoint (see .dynamic-environments for more info)
 *
 * This file will contain the environment variables from the .env
 * mounted to the filesystem. This will then dynamically swap out
 * the variables in Nuxt with these variables.
 */
export default (context, inject) => {
  // When the dynamic environments env is not present, do not proceed. This is likely because
  // we're running a different environment like local or production.

  if (!window._dynamic_environments_env) return;

  const dynamicEnv = window._dynamic_environments_env || {};

  // The environmentVariableMapper maps the raw env format in capital-underscore case to
  // the correct casing used for the application config (see nuxt.config.js)
  // when you add a new variable, you will also need to add it here.

  const environmentVariableMapper = {
    PLANNR_LARAVEL_URL: 'laravelURL',
    PLANNR_NEXT_URL: 'plannrNextURL',
    PORTAL_URL: 'portalURL',
    SYNCFUSION_KEY: 'syncFusionKey',
    BE_IQ_STYLE_URL: 'beIqStyleUrl',
    BE_IQ_SCRIPT_URL: 'beIqScriptUrl',
    RQ_RATINGS_SCRIPT_URL: 'rqRatingScriptUrl',
    PENSION_LAB_SCRIPT_URL: 'pensionLabScript',
    PENSION_LAB_CLIENT_ID: 'pensionLabClientId',
    // PUSHER_APP_KEY - Purposely excluded as this is passed at build time.
    // PUSHER_CLUSTER - Purposely excluded as this is passed at build time.
    // NODE_ENV - Purposely excluded as this is passed at build time.
  };

  // Loop over each of the dynamic environment variables, find the name of the variable in
  // the Nuxt config and replace it. This will then apply to the rest of the application.

  Object.keys(dynamicEnv).forEach((key) => {
    const configKey = environmentVariableMapper[key] || key;
    context.$config[configKey] = dynamicEnv[key];
  });
};
